import { resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/banner-insurance-v2.svg'


const _hoisted_1 = {
  key: 0,
  class: "relative",
  style: {"padding-top":"1.5rem"}
}
const _hoisted_2 = {
  key: 0,
  class: "flex justify-center"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  style: {"margin-top":"-1.6rem"},
  class: "w-full",
  src: _imports_0,
  alt: "info-banner-insurance"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_ctx.textContent)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        (_ctx.isInsuranceVisible && _ctx.isRetail)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode("div", {
                class: 
          `text-white font-normal ${
            _ctx.textContent.length > 180 ? 'text-16px' : 'text-20px'
          } font-montserrat absolute text-center w-4/5`
        
              }, [
                _withDirectives(_createVNode("p", null, null, 512), [
                  [_directive_sanitize_html, _ctx.textContent]
                ])
              ], 2),
              _hoisted_3
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}